import CloseIcon from "@mui/icons-material/Close";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  ControlpanelSecondaryButton,
  GrayIconButton,
} from "../../../components/StyledButton";
import { CustomDialog } from "../../../components/StyledComponents";

const ShowInfoDeviceDialog = (props) => {
  const { title, listDevice = [], open, handleClose } = props;
  const { t } = useTranslation();

  const devices = Array.isArray(listDevice) ? listDevice : [];

  return (
    <CustomDialog
      transitionDuration={300}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      keepMounted
    >
      <DialogTitle>
        <div className="flex justify-between">
          <div className="flex items-center gap-4">
            <p className="text-xl font-semibold">{title}</p>
          </div>
          <GrayIconButton onClick={handleClose}>
            <CloseIcon />
          </GrayIconButton>
        </div>
      </DialogTitle>

      <DialogContent className="!py-0">
        <div
          className="my-4"
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: 16,
            overflow: "hidden",
            background: "#fff",
            maxHeight: 420,
            overflowY: "auto",
          }}
        >
          {devices.length === 0 ? (
            <div
              className="flex items-center justify-center"
              style={{ minHeight: 120 }}
            >
              <span className="text-gray-500">{t("common.no-data")}</span>
            </div>
          ) : (
            devices.map((device, index) => {
              // COMPANY/GROUP: chỉ hiện deviceName làm title
              // Mobile: trái = fullName + identifier, phải = deviceName
              const isCompanyGroup =
                String(device.deviceType || "")
                  .trim()
                  .toUpperCase() === "COMPANY/GROUP";

              const titleText = isCompanyGroup
                ? device.deviceName || "-"
                : device.fullName || "-";
              const subText = device.indetifier || device.identifier || "-";
              const rightText = !isCompanyGroup
                ? device.deviceName || "-"
                : null;

              return (
                <div
                  key={device.id || device.deviceId || index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 14px",
                    borderBottom:
                      index !== devices.length - 1
                        ? "1px solid #e5e7eb"
                        : "none",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#1F2937",
                      }}
                    >
                      {titleText}
                    </div>
                    <div
                      style={{
                        marginTop: 4,
                        fontSize: 12,
                        color: "#6B7280",
                      }}
                    >
                      {subText}
                    </div>
                  </div>

                  {rightText != null && (
                    <div
                      style={{
                        color: "#1F2937",
                        fontWeight: 500,
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        marginLeft: 12,
                      }}
                    >
                      {rightText}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <div className="flex gap-2 px-4 py-4">
          <ControlpanelSecondaryButton onClick={handleClose}>
            <p>{t("button.close")}</p>
          </ControlpanelSecondaryButton>
        </div>
      </DialogActions>
    </CustomDialog>
  );
};

export default ShowInfoDeviceDialog;
